import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import ViewUIPlus from 'view-ui-plus'
import * as echarts from 'echarts'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import './assets/css/bx.css'
import './assets/styles/fzmetrics.css'

const app = createApp(App)

app.config.globalProperties.$echarts = echarts

app.use(router).use(ViewUIPlus).mount('#app')
